import { FC } from 'react'
import { CityText } from './Footer.styles'

export type CitiesProps = {
  domain: string
  cities: {
    url: string
    title: string
  }[]
}

const Cities: FC<CitiesProps> = ({ cities, domain }) => {
  const showNoFollow = domain === 'housekeeper.com'

  return (
    <>
      {cities.map((item) => (
        <CityText
          textAlign={{ _: 'center', desktop: 'left' }}
          href={`https://${item.url}`}
          key={item.url}
          rel={showNoFollow ? 'nofollow' : ''}
          role='listitem'
        >
          {item.title}
        </CityText>
      ))}
    </>
  )
}

export default Cities
